import { z } from 'zod';

import { CommunicationInterfaces } from '../fields/CommunicationInterfaces';
import { CommunicationProtocols } from '../fields/CommunicationProtocols';

const communication = z
    .object({
        interfaces: CommunicationInterfaces.validator.default([]),
        protocols: CommunicationProtocols.validator.default([]),
    })
    .default({});

export { communication };
